module.exports = __webpack_public_path__ + "static/media/monitoramento@2x.882eea34.png";